<template>
  <small-modal
    class="add-title-modal"
    :title="$t('create.bulk.tags.title')"
    :fit-content="true"
    @close="$emit('close')"
  >
    <h2 class="subtitle">
      {{ $t("create.bulk.tags.subtitle") }}<span>{{ feed.feedName }}</span>
    </h2>
    <div class="add-title-modal-container">
      <banner-modal
        class="banner-modal"
        :title="$t('create.bulk.tags.bannerTitle')"
        :text="$t('create.bulk.tags.bannerText')"
      />
      </span>
      <TagsManager
        :feed="feed"
        :feed-index="feedIndex"
        :is-feed-manager="true"
        :campaign-id="campaignId"
        :all-feeds="allFeeds"
      />
    </div>
  </small-modal>
</template>

<script>
import SmallModal from "@/components/shared/SmallModal.vue";
import BannerModal from "@/components/shared/BannerModal.vue";
import TagsManager from "@/components/campaign-manager/TagsManager.vue";
import { mapGetters } from "vuex";

export default {
  components: { SmallModal, BannerModal, TagsManager },
  props: {
    feed: { type: Object, required: true },
    feedIndex: { type: Number, required: true },
    campaignId: { type: String, required: true },
    allFeeds: { type: Array, default: () => [] },
  },
  computed: {
    ...mapGetters({
      siteId: "account/getSiteId",
    }),
  },
  async created() {
    await this.$store.dispatch("tag/getTags", { siteId: this.siteId });
  }
};
</script>

<style lang="scss" scoped>
.subtitle {
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
  span {
    font-style: italic;
  }
}
.banner-modal {
  margin-bottom: 24px;
  min-width: 480px;
}
</style>
